// Estado de la invitación de Google Calendar de una demo (v_demos), tal como la deja
// v_demoGoogleInvite: google_event_id + invite_status (responseStatus del invitado en Google).
// Puro: decide si se pinta el chip y con qué clave. Sin google_event_id no hubo invitación
// (lead sin email o closer sin Google conectado) y no se pinta nada; "cancelled" = la demo
// se canceló y Google ya avisó al lead, tampoco aporta.
const MAP = {
  needsAction: "pending",
  accepted: "accepted",
  declined: "declined",
  tentative: "tentative",
};

export function inviteChipInfo(demo) {
  if (!demo || !demo.google_event_id) return null;
  const raw = demo.invite_status;
  const key = raw ? MAP[raw] : "pending";
  if (!key) return null;
  return {
    key,
    email: demo.invite_email || "",
    answeredAt: key !== "pending" && demo.invite_status_at ? demo.invite_status_at : null,
  };
}
